"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CMS_ENDPOINTS_1 = __importDefault(require("../../../constants/app/CMS_ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
/**
 * Client interface to get City content
 * @param appEnv {string}
 * @returns Promise
 */
const getCityContent = (appEnv, locale) => {
    const requestId = 'CITY_CONTENT';
    const baseUrl = CMS_ENDPOINTS_1.default.BASE_URL[appEnv];
    const rawEndpoint = `${baseUrl}${CMS_ENDPOINTS_1.default.CMS_SERVICE.CITY}`;
    const endPoint = rawEndpoint.replace('{locale}', locale);
    return http_service_1.default.get(requestId, endPoint).then((response) => response.data);
};
exports.default = getCityContent;
